export interface DataTableColumn {
  key: string
  // `name` mirrors `label` for `export_csv` back-compat — its CSV writer reads
  // `column.name`. Drop once exports migrate to a label-aware util.
  name: string
  label: string
  type: 'boolean' | 'currency' | 'date' | 'integer' | 'multiple' | 'number' | 'percent' | 'string'
  align?: 'left' | 'center' | 'right'
  hidden?: boolean
  aggregate?: ((items: any[]) => any) | null
  flatten?: (item: any) => any
}

const ADDRESS_FIELDS = [
  { suffix: 'line1', label: 'Line 1' },
  { suffix: 'line2', label: 'Line 2' },
  { suffix: 'city', label: 'City' },
  { suffix: 'state', label: 'State' },
  { suffix: 'postal_code', label: 'Postal Code' },
  { suffix: 'country', label: 'Country' },
] as const

export const addressColumns = ({ keyPrefix = '' }: { keyPrefix?: string } = {}): DataTableColumn[] => {
  const resolveAddress = keyPrefix ? (item: any) => item?.[keyPrefix]?.address : (item: any) => item?.address

  const keyPrefixFlat = keyPrefix ? `${keyPrefix}_` : ''

  return ADDRESS_FIELDS.map(({ suffix, label }) => ({
    key: `${keyPrefixFlat}address_${suffix}`,
    name: label,
    label,
    type: 'string' as const,
    hidden: true,
    flatten: (item: any) => resolveAddress(item)?.[suffix],
  }))
}
